/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Delete_Account_BtnInputs */

const en_dialog_delete_account_btn = /** @type {(inputs: Dialog_Delete_Account_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete account`)
};

const es_dialog_delete_account_btn = /** @type {(inputs: Dialog_Delete_Account_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

/**
* | output |
* | --- |
* | "Delete account" |
*
* @param {Dialog_Delete_Account_BtnInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_account_btn = /** @type {((inputs?: Dialog_Delete_Account_BtnInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Account_BtnInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_account_btn(inputs)
	return en_dialog_delete_account_btn(inputs)
});